import FacebookRounded from '@mui/icons-material/FacebookRounded';
import { Button } from '@mui/material';

export default function FacebookLoginButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variant="contained"
      style={{ backgroundColor: "#1a77f2", color: "#fff", borderRadius: "4px", padding: "6px 16px" }}
      startIcon={<FacebookRounded />}
      onClick={onClick}
    >
      Login with Facebook
    </Button>
  );
};
